<div class="card-with-counter" [attr.data-qa]="'cardWithCounter_container'">
  <div class="card-with-counter__content-top">
    <div class="card-with-counter__content-top__left">
      <lx-image
        class="card-with-counter__img"
        [attr.data-qa]="'cardWithCounter_img'"
        [image]="imgSource"
        [fallbackImage]="fallbackImage"
        [width]="170"
        [height]="104"
        alt="Card image"
      />
    </div>
    <div class="card-with-counter__content-top__right">
      <div>
        <div class="card-with-counter__title">{{ title }}</div>
        <div class="card-with-counter__description">{{ description }}</div>
      </div>

      <ng-container *ngIf="!!!(isMobile$ | async)">
        <ng-container *ngTemplateOutlet="weeksCounterTemplate"></ng-container>
      </ng-container>
    </div>
  </div>
  <ng-container *ngIf="isMobile$ | async">
    <ng-container *ngTemplateOutlet="weeksCounterTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #weeksCounterTemplate>
  <div class="card-with-counter__content-bottom">
    <lx-weeks-counter
      [rightButtonDisabled]="rightButtonDisabled"
      [value]="weeks"
      [min]="min"
      [max]="max"
      (valueChanged)="selectValue($event)"
      [attr.data-qa]="'cardWithCounter_weeksCounter'"
    >
    </lx-weeks-counter>
    <lx-price-label [price]="price" [endPrice]="endPrice" [discount]="discount" [disabled]="weeks === 0" [currency]="currency?.()"></lx-price-label>
  </div>
</ng-template>
